module.exports = __webpack_public_path__ + "static/media/covi_ppe_rad.e95eeab4.png";